import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { SUMMIT } from "@/constants/summit";
import { Reveal, SectionHeading } from "@/components/Reveal";

const VideoInvite = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const startPlayback = () => {
    videoRef.current?.play();
  };

  return (
    <section id="film" data-testid="video-invite-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          index="01"
          kicker="Video Invitation"
          title={<>A personal invitation,<br className="hidden sm:block" /> from our host to you.</>}
        />
        <Reveal delay={0.15} className="mt-12">
          <div
            data-testid="video-invite-iframe-container"
            className="orange-glow relative aspect-video w-full overflow-hidden rounded-2xl border border-brand-500/40 bg-charcoal"
          >
            {SUMMIT.videoEmbedUrl ? (
              <iframe
                src={SUMMIT.videoEmbedUrl}
                title="The Choice — Official Video Invitation"
                className="absolute inset-0 h-full w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : SUMMIT.videoUrl ? (
              <>
                <video
                  ref={videoRef}
                  data-testid="video-invitation-player"
                  className="absolute inset-0 h-full w-full object-cover"
                  poster="/assets/hero-dusk.jpg"
                  controls={playing}
                  playsInline
                  preload="metadata"
                  onPlay={() => setPlaying(true)}
                  onPause={() => setPlaying(false)}
                  onEnded={() => setPlaying(false)}
                >
                  <source src="/assets/video-invitation.webm" type="video/webm" />
                  <source src={SUMMIT.videoUrl} type="video/mp4" />
                </video>
                {!playing && (
                  <button
                    data-testid="hero-video-trigger-button"
                    onClick={startPlayback}
                    aria-label="Play the video invitation"
                    className="group absolute inset-0 flex flex-col items-center justify-center gap-6 bg-gradient-to-t from-obsidian/80 via-obsidian/20 to-transparent transition-colors duration-500 hover:via-obsidian/10"
                  >
                    <span className="relative grid h-20 w-20 place-items-center rounded-full bg-brand-500 shadow-[0_0_50px_rgba(255,87,34,0.6)] transition-transform duration-300 group-hover:scale-110">
                      <span className="absolute inset-0 animate-ping rounded-full bg-brand-500/40" />
                      <Play className="h-8 w-8 fill-white text-white" />
                    </span>
                    <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] text-white/80">
                      The Official Video Invitation
                    </span>
                  </button>
                )}
              </>
            ) : (
              <div className="absolute inset-0">
                <img src="/assets/hero-dusk.jpg" alt="" className="h-full w-full object-cover opacity-40" />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/40 to-transparent" />
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 px-6 text-center">
                  <span className="relative grid h-20 w-20 place-items-center rounded-full bg-brand-500 shadow-[0_0_50px_rgba(255,87,34,0.6)]">
                    <span className="absolute inset-0 animate-ping rounded-full bg-brand-500/40" />
                    <Play data-testid="hero-video-trigger-button" className="h-8 w-8 fill-white text-white" />
                  </span>
                  <p className="font-display text-xl sm:text-2xl font-bold">The Official Video Invitation</p>
                </div>
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default VideoInvite;
